import { Component, OnInit } from "@angular/core";
import { DataService } from "src/app/services/data.service";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { Router, ActivatedRoute } from "@angular/router";
import { Title } from "@angular/platform-browser";
import { ElementRef, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { buildSEOImageUrl } from "src/app/utils/seo-image.helper";
@Component({
  selector: "app-search",
  templateUrl: "./search.component.html",
  styleUrls: ["./search.component.scss"],
})

export class SearchComponent implements OnInit {
  @ViewChild('masonryContainer') masonryContainer!: ElementRef;
  gap = 16;
  resizeObserver!: ResizeObserver;
  minItemWidth = 264; // controls how many columns per device
  imageLoadCount = 0;
  cateData: any = [];

  id = "";
  category = "";
  searchkey = "Illustration";
  searchType = "";
  searchvalue = "";
  collectionData: any = [];
  visibleCollectionData: any[] = [{}, {}, {}, {}, {}, {}, {}, {}];   // rendered data
  pageSize = 20;
  currentPage = 1;
  isLoadingMore = false;

  collections: any = [];
  collectionsDataCard: any = [];
  visibleCollectionsDataCard: any[] = [{}, {}, {}, {}, {}, {}, {}, {}];
  collectionsPageSize = 20;
  collectionsCurrentPage = 1;
  isCollectionsLoadingMore = false;

  loader = true;
  imageLoad = true;
  aiImages = false;
  isDataLoading = true;

  constructor(
    private dataService: DataService,
    private afs: AngularFirestore,
    public router: Router,
    private route: ActivatedRoute,
    private title: Title
  ) {
    this.route.queryParams.subscribe((params) => {
      // console.log(params);
      this.searchvalue = params["value"];
      params["searchKey"] ? (this.searchkey = params["searchKey"]) : null;
      this.category = params["cate"];
      this.searchType = params["searchType"] || "";
      if ("AI Images" == decodeURI(this.searchkey)) {
        this.aiImages = true;
        this.handleCateName();
        this.collectionsDataCard = [];
        this.collectionData = [];
      } else {
        this.aiImages = false;
        this.handleCateName();
        this.collectionsDataCard = [];
        this.collectionData = [];
      }
      // console.log(this.category, params["cate"]);

      if (this.searchvalue || this.category) {
        this.handleSearch();
      }
    });
  }

  getSEOImage(url: string): string {
    return buildSEOImageUrl(url);
  }

  async ngOnInit() {
    this.title.setTitle(`Search | Illusbook`);

    if (this.searchkey) {
      this.searchkey = this.searchkey;

      if ("AI Images" == decodeURI(this.searchkey)) {
        this.aiImages = true;
        this.handleCateName();
      } else {
        this.aiImages = false;
        this.handleCateName();
      }
    }
  }

  async handleCateName() {
    (await this.dataService.getCategoryService()).subscribe((singleservice) => {
      this.cateData = [];
      this.cateData = singleservice.filter((c: any) =>
        this.aiImages ? c.isAICategory : !c.isAICategory
      );
      this.imageLoad = false;
      this.loader = false;
    });
  }

  async handleSearch() {
    this.isDataLoading = true;
    this.collectionData = [];
    this.collectionsDataCard = [];

    if (this.searchkey === "Collections") {
      await this.handleCollectionsSearch();
    } else {
      await this.handleIllustrationsSearch();
    }
  }

  async handleIllustrationsSearch() {
    try {
      const data = await this.getSingleService(this.searchkey);
      data.subscribe((singleservice) => {
        // Filter data based on category
        this.collectionData = this.category
          ? singleservice
          : singleservice.filter((item) => this.matchesSearchCriteria(item));

        // Extract unique collections using Set for better performance
        this.collections = [
          ...new Set(
            this.collectionData
              .map((data) => data.collections)
              .filter((collection) => collection != null)
          ),
        ];

        // console.log(this.collectionData);
        this.sortBy("popular");
        this.isDataLoading = false;   // 🔥 DONE LOADING
        this.initIllusLoad();   // ✅ after data assignment
        this.getCollectionData();

      });
    } catch (error) {
      console.error("Error in handleIllustrationsSearch:", error);
    }
  }

  private matchesSearchCriteria(item: any): boolean {
    const searchValueLower = this.searchvalue?.toLowerCase() || "";

    switch (this.searchkey) {
      case "Illustration":
        return (
          !item.isAIIllustration &&
          item.title?.toLowerCase().includes(searchValueLower)
        );

      case "Collections":
        return (
          !item.isAICollection &&
          item.collections?.toLowerCase().includes(searchValueLower)
        );

      case "AI Images":
        return (
          item.isAIIllustration &&
          item.title?.toLowerCase().includes(searchValueLower)
        );

      default:
        return (
          !item.isAICollection &&
          item.title?.toLowerCase().includes(searchValueLower)
        );
    }
  }

  async handleCollectionsSearch() {
    try {
      if (this.searchvalue) {
        // Search collections by name
        await this.searchCollectionsByName();
      } else if (this.category) {
        // Get collections by category
        await this.getCollectionsByCategory();
      }
    } catch (error) {
      console.error("Error in handleCollectionsSearch:", error);
    }
  }

  async searchCollectionsByName() {
    const data = await this.getSingleService(this.searchkey);
    data.subscribe((singleservice) => {
      const filteredCollections = singleservice.filter(
        (collection: any) =>
          !collection.isAICollection &&
          collection.collectionName
            ?.toLowerCase()
            .includes(this.searchvalue?.toLowerCase())
      );

      this.collectionsDataCard = filteredCollections.map((val: any) => ({
        name: val.collectionName,
        id: val.id,
        bUrl: val.bannerUrl,
        tUrl: val.thumbUrl,
        slug: val.slug,
        imageLoad: false,
        isAICollection: val.isAICollection || false,
      }));
      this.isDataLoading = false;
      this.initCollectionLoad();   // ✅ after data assignment
    });

  }

  async getCollectionsByCategory() {
    // Since category name IS the collection name, directly fetch the collection
    const collectionQuery = await this.afs.collection(
      `collectionMaster/`,
      (res) => {
        return res
          .where("collectionName", "==", this.category)
          .where("isActive", "==", "Active");
      }
    );

    const collectionData = await collectionQuery.valueChanges({
      idField: "id",
    });

    collectionData.subscribe((collections) => {
      collections.forEach((val: any) => {
        // Check if already exists to avoid duplicates
        const exists = this.collectionsDataCard.some(
          (item) =>
            item.id === val.id && item.isAICollection === !!val.isAICollection
        );
        if (!exists) {
          this.collectionsDataCard.push({
            name: val.collectionName,
            id: val.id,
            bUrl: val.bannerUrl,
            tUrl: val.thumbUrl,
            slug: val.slug,
            imageLoad: false,
            isAICollection: val.isAICollection || false,
          });
        }
      });
      this.isDataLoading = false;
    });

  }

  getCollectionData() {
    if (this.collections.length === 0) return;

    this.collections.forEach(async (collectionName) => {
      try {
        const get = await this.afs.collection(`collectionMaster/`, (res) => {
          return res
            .where("collectionName", "==", collectionName)
            .where("isActive", "==", "Active");
        });

        const getdata = await get.valueChanges({ idField: "id" });
        getdata.subscribe((data) => {
          data.forEach((val: any) => {
            // Check if already exists to avoid duplicates
            const exists = this.collectionsDataCard.some(
              (item) =>
                item.id === val.id &&
                item.isAICollection === !!val.isAICollection
            );
            if (!exists) {
              const obj = {
                name: val.collectionName,
                id: val.id,
                bUrl: val.bannerUrl,
                tUrl: val.thumbUrl,
                slug: val.slug,
                imageLoad: false,
                isAICollection: val.isAICollection || false,
              };
              this.collectionsDataCard.push(obj);
            }
          });
          this.getCollectionFileData();
        });
      } catch (error) {
        console.error("Error fetching collection data:", error);
      }
    });
  }

  getCollectionFileData() {
    this.collectionsDataCard.forEach(async (data) => {
      try {
        let query;
        if (this.category) {
          if (data.name) {
            query = await this.afs.collection(`filesMaster/`, (res) => {
              return res
                .where("collections", "==", data.name)
                .where("categories", "array-contains", this.category)
                .where("status", "==", "Published");
            });
          }
        } else {
          if (data.name) {
            query = await this.afs.collection(`filesMaster/`, (res) => {
              return res
                .where("collections", "==", data.name)
                .where("status", "==", "Published");
            });
          }
        }

        const getdata = await query?.valueChanges({ idField: "id" });
        getdata?.subscribe((fdata) => {
          data["files"] = fdata;
        });

        // console.log(this.collectionsDataCard);
      } catch (error) {
        console.error("Error fetching collection file data:", error);
      }
    });
  }

  // mansory style

  onImageLoad(index: number, event: Event) {
    const img = event.target as HTMLImageElement;
    this.collectionData[index].imageLoad = true;

    // store real image ratio
    this.collectionData[index].ratio =
      img.naturalHeight / img.naturalWidth;

    img.classList.add('loaded');

    this.scheduleMasonry();
  }

  ngAfterViewInit() {
    this.scheduleMasonry();

    this.resizeObserver = new ResizeObserver(() => {
      this.scheduleMasonry();
    });

    this.resizeObserver.observe(this.masonryContainer.nativeElement);
  }

  ngOnDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  scheduleMasonry() {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.buildMasonry();
      });
    });
  }



  buildMasonry() {
    const container = this.masonryContainer.nativeElement;
    const items = Array.from(
      container.querySelectorAll('.masonry-item')
    ) as HTMLElement[];

    if (!items.length) return;

    const containerWidth = container.clientWidth - 32; // padding
    let columnCount = Math.floor(
      (containerWidth + this.gap) /
      (this.minItemWidth + this.gap)
    );

    if (columnCount < 1) columnCount = 1;

    columnCount = Math.max(1, Math.min(columnCount, 5));

    // two columns on mobile view
    // if (containerWidth < 480) {
    //   columnCount = 2;
    // }

    const itemWidth =
      (containerWidth - (columnCount - 1) * this.gap) /
      columnCount;

    const colHeights = new Array(columnCount).fill(0);

    items.forEach((item, i) => {
      const data = this.visibleCollectionData[i];

      item.style.width = `${itemWidth}px`;

      // calculate height using real image ratio
      const height = data.ratio
        ? itemWidth * data.ratio
        : itemWidth * 0.75;

      // shortest column
      let col = 0;
      for (let j = 1; j < columnCount; j++) {
        if (colHeights[j] < colHeights[col]) col = j;
      }

      const x = col * (itemWidth + this.gap);
      const y = colHeights[col];

      item.style.transform = `translate(${x}px, ${y}px)`;

      colHeights[col] += height + this.gap;
    });

    container.style.height =
      Math.max(...colHeights) + 'px';
  }

  sortBy(data: string) {
    if (this.searchkey === "Collections") {
      let nData = [...this.visibleCollectionsDataCard];

      if (data === "recent") {
        this.visibleCollectionsDataCard = nData.sort(
          (a, b) =>
            new Date(b.createdOn || 0).getTime() -
            new Date(a.createdOn || 0).getTime()
        );
      } else if (data === "popular") {
        this.visibleCollectionsDataCard = nData.sort(
          (a, b) => (b.isPopular ? 1 : 0) - (a.isPopular ? 1 : 0)
        );
      } else {
        this.visibleCollectionsDataCard = nData;
      }
    } else {
      let nData = [...this.visibleCollectionData];

      if (data === "recent") {
        this.visibleCollectionData = nData.sort(
          (a, b) => b.createdOn - a.createdOn
        );
      } else if (data === "popular") {
        this.visibleCollectionData = nData.sort(
          (a, b) => (b.isPopular ? 1 : 0) - (a.isPopular ? 1 : 0)
        );
      } else if (data === "free") {
        this.visibleCollectionData = nData.sort(
          (a, b) => (a.isPremium ? 1 : 0) - (b.isPremium ? 1 : 0)
        );
      } else if (data === "pro") {
        this.visibleCollectionData = nData.sort(
          (a, b) => (b.isPremium ? 1 : 0) - (a.isPremium ? 1 : 0)
        );
      }
    }

    // 🔥 IMPORTANT
    setTimeout(() => this.buildMasonry(), 0);
  }


  // sortBy(data: string) {
  //   if (this.searchkey === "Collections") {
  //     // Sort collections
  //     let nData = [...this.collectionsDataCard];
  //     this.collectionsDataCard = [];

  //     if (data === "recent") {
  //       this.collectionsDataCard = nData.sort((a, b) => {
  //         return (
  //           new Date(b.createdOn || 0).getTime() -
  //           new Date(a.createdOn || 0).getTime()
  //         );
  //       });
  //     } else if (data === "popular") {
  //       this.collectionsDataCard = nData.sort((a, b) => {
  //         const aVal = a.isPopular ? 1 : 0;
  //         const bVal = b.isPopular ? 1 : 0;
  //         return bVal - aVal;
  //       });
  //     } else {
  //       this.collectionsDataCard = nData;
  //     }
  //   } else {
  //     // Sort illustrations
  //     let nData = [...this.collectionData];
  //     this.collectionData = [];

  //     if (data === "recent") {
  //       this.collectionData = nData.sort((a, b) => b.createdOn - a.createdOn);
  //     } else if (data === "popular") {
  //       this.collectionData = nData.sort((a, b) => {
  //         const aVal = a.isPopular ? 1 : 0;
  //         const bVal = b.isPopular ? 1 : 0;
  //         return bVal - aVal;
  //       });
  //     } else if (data === "free") {
  //       this.collectionData = nData.sort((a, b) => {
  //         const aVal = a.isPremium ? 1 : 0;
  //         const bVal = b.isPremium ? 1 : 0;
  //         return aVal - bVal;
  //       });
  //     } else if (data === "pro") {
  //       this.collectionData = nData.sort((a, b) => {
  //         const aVal = a.isPremium ? 1 : 0;
  //         const bVal = b.isPremium ? 1 : 0;
  //         return bVal - aVal;
  //       });
  //     }
  //   }
  // }

  async getSingleService(key) {
    // console.log(this.category, key);
    let get: any;

    if (key !== undefined && key !== "Collections") {
      if (this.category) {
        get = await this.afs.collection(`filesMaster/`, (res) => {
          return res
            .where("categories", "array-contains", this.category)
            .where("status", "==", "Published")
            .orderBy("createdOn", "desc");
        });
      } else {
        get = await this.afs.collection(`filesMaster/`, (res) => {
          return res
            .where("status", "==", "Published")
            .orderBy("createdOn", "desc");
        });
      }
    } else if (key === "Collections") {
      get = await this.afs.collection(`collectionMaster/`, (res) => {
        return res
          .where("isActive", "==", "Active")
          .orderBy("createdOn", "desc");
      });
    }

    if (get) {
      const getdata = await get.valueChanges({ idField: "id" });
      return getdata;
    }

    // Return empty observable for Collections searchkey
    return new Promise((resolve) =>
      resolve({ subscribe: (callback) => callback([]) })
    );
  }

  initIllusLoad() {
    this.currentPage = 1;
    this.visibleCollectionData = this.collectionData.slice(0, this.pageSize);
  }

  loadMoreIllus() {
    this.isLoadingMore = true;

    setTimeout(() => {
      this.currentPage++;

      this.visibleCollectionData = this.collectionData.slice(
        0,
        this.currentPage * this.pageSize
      );

      this.isLoadingMore = false;
    }, 300);
  }

  get hasMoreIllus(): boolean {
    return this.visibleCollectionData.length < this.collectionData.length;
  }



  initCollectionLoad() {
    this.collectionsCurrentPage = 1;
    this.visibleCollectionsDataCard = this.collectionsDataCard.slice(
      0,
      this.collectionsPageSize
    );
  }

  loadMoreCollection() {
    this.isCollectionsLoadingMore = true;

    setTimeout(() => {
      this.collectionsCurrentPage++;

      this.visibleCollectionsDataCard = this.collectionsDataCard.slice(
        0,
        this.collectionsCurrentPage * this.collectionsPageSize
      );

      this.isCollectionsLoadingMore = false;
    }, 300);
  }

  get hasMoreCollection(): boolean {
    return this.visibleCollectionsDataCard.length < this.collectionsDataCard.length;
  }
}